import React from "react";
import styled from "styled-components";

const EyebrowContainer = styled.p`
  font-family: "supply", monospace;
  text-transform: uppercase;
  font-size: ${({ $small, $fontSize }) =>
    $fontSize ? $fontSize : $small ? "12px" : "14px"};
  line-height: 15.4px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || "16px"};
  margin-top: ${({ $marginTop }) => $marginTop || 0};
  color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};
  ${({ $decorated = false }) =>
    $decorated &&
    `
    &:after {
      content: " —"
    }
  `};
`;

function Eyebrow({
  children,
  small,
  marginBottom,
  marginTop,
  decorated,
  colour,
  fontSize,
  ...props
}) {
  return (
    <EyebrowContainer
      $colour={colour}
      $small={small}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
      $decorated={decorated}
      $fontSize={fontSize}
      {...props}
    >
      {children}
    </EyebrowContainer>
  );
}

export default Eyebrow;
